import React, { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Tag } from 'antd';
import { FiArrowUpRight } from 'react-icons/fi';
import { DataTable } from '@components/data-table';
import { AirflowTaskDefinition } from '../../types';

type TasksTableProps = {
    tasks: AirflowTaskDefinition[];
    isLoading: boolean;
    onTaskClick: (task: AirflowTaskDefinition) => void;
};

/*
 * Task-definition table for the DAG Tasks tab
 */
export function TasksTable({ tasks, isLoading, onTaskClick }: TasksTableProps) {
    const columns = useMemo<ColumnDef<AirflowTaskDefinition>[]>(
        () => [
            {
                id: 'task_id',
                header: 'Task ID',
                enableSorting: false,
                cell: ({ row }) => {
                    const task = row.original;
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ width: 8, height: 8, borderRadius: '50%', background: task.ui_color ?? '#666a8d', flexShrink: 0 }} />
                            <span style={{ color: '#fcad01' }}>{task.task_display_name ?? task.task_id}</span>
                            <FiArrowUpRight size={12} style={{ opacity: 0.6 }} />
                        </span>
                    );
                },
            },
            {
                id: 'operator',
                header: 'Operator',
                enableSorting: false,
                cell: ({ row }) => <Tag>{row.original.operator_name ?? row.original.class_ref?.class_name ?? '—'}</Tag>,
            },
            { id: 'owner', header: 'Owner', enableSorting: false, cell: ({ row }) => row.original.owner ?? '—' },
            { id: 'trigger_rule', header: 'Trigger Rule', enableSorting: false, cell: ({ row }) => (row.original.trigger_rule ?? '').replace(/_/g, ' ') || '—' },
            { id: 'retries', header: 'Retries', enableSorting: false, cell: ({ row }) => row.original.retries ?? '—' },
            { id: 'pool', header: 'Pool', enableSorting: false, cell: ({ row }) => row.original.pool ?? '—' },
            { id: 'downstream', header: 'Downstream', enableSorting: false, cell: ({ row }) => row.original.downstream_task_ids?.length ?? 0 },
        ],
        []
    );

    return <DataTable data={tasks} columns={columns} isLoading={isLoading} onRowClick={onTaskClick} rowKey={(task) => task.task_id} emptyText="No tasks found" />;
}
